import React from 'react';
import {Form, Input, Button, Icon, Alert} from 'antd';
import {Link} from 'react-router';
import img from '../style/imgs/banner.png';
import {APP_TITLE} from '../constants/configValues'
const FormItem = Form.Item;

class ForgotPasswordForm extends React.Component {
  render() {
    const {fetching, error, onSubmit, form} = this.props;
    const {getFieldDecorator} = form;
    const errorElement = error
      ? <Alert type="error" message={error} banner="banner"/>
      : <div className="error"></div>;
    return (<div className="login">
      <div className="login-form">
        <img src={img} alt="banner" className="banner"/>
        <div className="title">{APP_TITLE}</div>
        <div className="title-form">Quên mật khẩu</div>
        {errorElement}
        <Form onSubmit={onSubmit}>
          <FormItem>
            {
              getFieldDecorator('email', {
                rules: [
                  {
                    required: true,
                    message: 'Phải nhập email!'
                  }, {
                    type: 'email',
                    message: 'Không phải email!'
                  }
                ]
              })(<Input prefix={<Icon type = "mail" />} placeholder="email"/>)
            }
          </FormItem>
          <FormItem>
            <Button loading={fetching} type="primary" htmlType="submit" className="btn-login">
              GỬI
            </Button>
            <Link to={'/login'}>Đăng nhập</Link>
          </FormItem>
        </Form>
      </div>
    </div>);
  }
}

export default Form.create()(ForgotPasswordForm)



// WEBPACK FOOTER //
// ./src/components/ForgotPasswordForm.js